// https://material.angular.io/components/table/overview
import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FacturaRegimenFiscal } from '../../models/facturaRegimenFiscal';
import { FacturaFormaPago } from '../../models/FacturaFormaPago';
import { FacturaMetodoPago } from '../../models/FacturaMetodoPago';
import { FacturaUsoCFDI } from '../../models/FacturaUsoCFDI';
import { FacturaUnidadMedida } from '../../models/facturaUnidadMedida';
import { Item } from '../../models/item';
import { Organizacion } from '../../models/organizacion';
import { ReciboPago, ReciboPagoDetalle, ReciboPagoDocumento } from '../../models/ReciboPago';
import { privateEncrypt } from 'crypto';
import { Usuario } from '../../models/usuario';
import { forEach } from 'core-js/fn/array';
import * as moment from 'moment';
import { BeneficiarioDetalleComponent } from '../cuenta-beneficiario/agregar-editar/cuenta-beneficiario-detalle.component';
import { OrdenanteDetalleComponent } from '../cuenta-ordenante/agregar-editar/cuenta-ordenante-detalle.component';
import { MatSelect } from '@angular/material/select';
import { Time } from '@angular/common';
/**
 * @title Table with pagination
 */
@Component({
  selector: 'my-recibo-pago-detalle',
  styleUrls: [],
  templateUrl: 'recibo-pago-detalle.component.html',
  providers: [generalService]
})
export class ReciboPagoDetalleComponent {
    public viewDataDoc: any[];
    public viewDataDocEdit: any[];
    private itemsShowDoc = 10;
    private filteredItemsShowDoc = 10;
    private arrayFilteredDoc = undefined;
    private isFilteredDoc = false;
    private listaDocumentoEdit: any[];
    @ViewChild('infiniteSelect') selectElem: MatSelect;

    reciboPago: ReciboPago = new ReciboPago();
    facturaTipo: number = null;
    idDocuments: string = null;
    price: number = null;
    
   
    
    totalFaltante: number = null;
    ventaDetalleListado: any[] = [];
    reciboPagoAgregar: FormGroup;

    siguiente: boolean = false;
    titulo = 'Agregar';
    id: number = null; // id factura

    
    listaFormaPago: FacturaFormaPago[] = [];

    listaCuentaOrdenante: any[] = [];
    listaCuentaBeneficiario: any[] = [];
    listaMoneda: any[] = [];
    listaDocumento: any[] = [];
    listaDocumentoSelect: any[] = [];

    saldoAnterior: number = 0;
    importePagado: number = 0;
    total: number = 0;

    BILL_TAX_REGIME_ID: number;

    public seEstaEditando = false;
    public seEstaAgregando = false;
    public transaccionEnCurso = false;

    listaReciboPagoDocumento: ReciboPagoDocumento[] = [];
    listaReciboPagoDocumentoAgregar: ReciboPagoDocumento[] = [];
    public dataSource = new MatTableDataSource<ReciboPagoDocumento>();
    public reciboPagoDocumento: ReciboPagoDocumento =  new ReciboPagoDocumento();
    public displayedColumns: string[] = [
      'acciones',
      'documento',
      'numeroFolio',
      'Moneda',
      'tipoCambioDoc',
      'saldoAnterior',
      'importePagado',
      'subtotal',
      'iva',
      'iva_factor',
      'saldo',
    ];
    public reciboPagoDetalle: ReciboPagoDetalle =  new ReciboPagoDetalle();
    public documentoControl = new FormControl(null, [Validators.required]);
    public UUIDControl = new FormControl(null, [Validators.required]);
    public monedaControl = new FormControl(null, [Validators.required]);
    public tipoCambioControl = new FormControl(null, [Validators.required]);
    public saldoAnteriorControl = new FormControl(null, [Validators.required]);
    public importePagadoControl = new FormControl(null, [Validators.required, Validators.pattern(/^\d*(?:[.,]\d{1,2})?$/)]);
    public saldoControl = new FormControl(true, [Validators.required]);
    public subtotalController = new FormControl(null, [Validators.required]);
    public IVAController = new FormControl(null, [Validators.required]);
    public IVAFactorController = new FormControl(null, [Validators.required]);

    public commentsControl = new FormControl(null);
    public idCliente = null;
    private formularioValido = true;

    public mostrarOrdenante = false;
    public mostrarBeneficiario = false;

    public containsTaxGeneral = true;
    private loacs;

    constructor(private formBuilder: FormBuilder, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService, private route: ActivatedRoute) {
        this.dataService.guardado = false;
       // this.id =  +(this.route.snapshot.paramMap.get('id'));
    }

    async ngOnInit() {
  
            this.loacs = sessionStorage.getItem("acslo");
            this.idCliente = this.dataService.factura.idCliente;
            this.buildForm();
            this.consultarMoneda();
            this.consultIVA();
            this.consultarDocumentos();
      

    }
    
    

    consultIVA() {
        this._generalService.metodoCallParams(this.loacs, 'itemLookUp/consultIVA')
            .subscribe(itemIVA => {
              itemIVA = JSON.parse(itemIVA);
              if(itemIVA.length > 0)
              {
                this.containsTaxGeneral = false;
              }
              else
              {
                this.containsTaxGeneral = true;
              }
              this.consultarDocumentos();
              this.consultarFormaPago();
              if (this.dataService.tipo === 'editar') {
                this.titulo = 'Editar';
                this.id = this.dataService.id;
                this.facturaTipo = this.dataService.factura.tipoFactura; // 1 Ventas y 2 Libre
                this.getReciboPago(this.dataService.id);
                //this.getFacturaDetalle(this.dataService.id);
              } else {
                this.idDocuments = this.dataService.factura.idDocuments;
                this.facturaTipo = this.dataService.factura.tipoFactura; // 1 Ventas y 2 Libre
                /*this.reciboPagoAgregar.controls['nombre'].setValue(this.dataService.factura.CUSTOMER_NAME);
                this.reciboPagoAgregar.controls['cfdi'].setValue(22); // Por Definir
                this.reciboPagoAgregar.controls['rfc'].setValue(this.dataService.factura.CUSTOMER_RFC);*/
                this.reciboPago = new ReciboPago();
                this.reciboPago.CUSTOMER_RFC = this.dataService.factura.CUSTOMER_RFC;
                this.reciboPago.CUSTOMER_NAME = this.dataService.factura.CUSTOMER_NAME;
                this.reciboPago.BILL_STATUS_ID = 1;
                if (this.facturaTipo === 1 && this.idDocuments !== null && this.idDocuments !== undefined) {
                    //this.getVentasDetalle();
                }
              }
              this.consultarCompania();
              this.consultarCuentaOrdenante();
              this.consultarCuentaBeneficiario();        

            }, error => {
              // Custom error handler
            });
    }

    getReciboPago(id: any) {
        this.listaReciboPagoDocumento = [];
        this.listaReciboPagoDocumentoAgregar = [];
        this.reciboPago.RECEIPT_PAYMENT_ID = this.dataService.id;
        this._generalService.metodoCallParams(this.reciboPago, `RecepcionPago/consultarReceiptPayment`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                this.reciboPago = res.Table[0];
                this.reciboPagoDetalle = res.Table1[0];
                //Uso de hora en el formulario
                const [FECH,HORA] = this.reciboPagoDetalle.PAYMENT_DATE.split(' '); 
                const [ANIO,MES,DIA] = FECH.split('-');
                const [HOUR,MIN,SEC] = HORA.split(':');
                this.reciboPagoAgregar.controls['horaPago'].setValue(HORA);
                this.reciboPagoAgregar.controls['fechaPago'].setValue(this.reciboPagoDetalle.PAYMENT_DATE);
                this.reciboPagoAgregar.controls['monto'].setValue(this.reciboPagoDetalle.AMOUNT);
                this.reciboPagoAgregar.controls['moneda'].setValue(this.reciboPagoDetalle.COIN_SAT_ID);
                this.reciboPagoAgregar.controls['formaPago'].setValue(this.reciboPagoDetalle.RECEIVER_PAYMENT_FORM_ID);
                this.reciboPagoAgregar.controls['numOperacion'].setValue(this.reciboPagoDetalle.NUM_OPERATION);
                this.reciboPagoAgregar.controls['cuentaOrdenante'].setValue(this.reciboPagoDetalle.ORIGINATOR_BACK_ACCOUNT_ID);
                this.reciboPagoAgregar.controls['cuentaBeneficiario'].setValue(this.reciboPagoDetalle.BENEFICIARY_BACK_ACCOUNT_ID);
                this.reciboPagoAgregar.controls['tipoCambio'].setValue(this.reciboPagoDetalle.EXCHANGE_RATE);
                this.commentsControl.setValue(this.reciboPagoDetalle.COMMENTS);

                if (this.reciboPago.BILL_STATUS_ID !== 1) {
                    this.displayedColumns = [
                        'documento',
                        'numeroFolio',
                        'Moneda',
                        'tipoCambioDoc',
                        'saldoAnterior',
                        'importePagado',
                        'subtotal',
                        'iva',
                        'iva_factor',
                        'saldo'
                    ];
                } else {
                    this.displayedColumns = [
                        'activo',
                        'acciones',
                        'documento',
                        'numeroFolio',
                        'Moneda',
                        'tipoCambioDoc',
                        'saldoAnterior',
                        'importePagado',
                        'subtotal',
                        'iva',
                        'iva_factor',
                        'saldo'
                    ];
                }

                res.Table2.forEach((element) => {
                    const id = this.listaReciboPagoDocumentoAgregar.length;
                    const moneda = this.listaMoneda.find((p) => p.COIN_SAT_ID === element.COIN_SAT_ID);
                    const docCon = this.listaDocumento.find((p) => p.BILL_ID === element.BILL_ID);
                    this.listaReciboPagoDocumento.push({
                        DOCTOS_RELATED_RECEIPT_PAYMENT_ID: element.DOCTOS_RELATED_RECEIPT_PAYMENT_ID,
                        RECEIPT_PAYMENT_DETAIL_ID: element.RECEIPT_PAYMENT_DETAIL_ID,
                        DOCUMENT_ID: element.DOCUMENT_ID,
                        BILL_ID: element.BILL_ID,
                        DOCUMENT_NUMBER: element.DOCUMENT_NUMBER,
                        COIN_SAT_ID: element.COIN_SAT_ID,
                        EXCHANGE_RATE: element.EXCHANGE_RATE,
                        RECEIVER_PAYMENT_METHOD_ID: element.RECEIVER_PAYMENT_METHOD_ID,
                        PARTIALITY_NUMBER: element.PARTIALITY_NUMBER,
                        PREVIOUS_BALANCE_AMOUNT: element.PREVIOUS_BALANCE_AMOUNT,
                        PAID_AMOUNT: element.PAID_AMOUNT,
                        UNPAID_BALANCE_AMOUNT: element.UNPAID_BALANCE_AMOUNT,
                        index: id,
                        isChecked: true,
                        CURRENCY: moneda.NAME,
                        CONDICIONAL: docCon.BILL_PAYMENT_METHOD_KEY,
                        LAST_PAID_AMOUNT: element.LAST_PAID_AMOUNT,
                        UUID: element.UUID,
                        IVA_FACTOR: element.IVA_FACTOR,
                        IVA_AMOUNT: element.IVA_AMOUNT,
                        SUBTOTAL_BEFORE_TAX: element.SUBTOTAL_BEFORE_TAX
                    });
                    this.listaReciboPagoDocumentoAgregar.push({
                        DOCTOS_RELATED_RECEIPT_PAYMENT_ID: element.DOCTOS_RELATED_RECEIPT_PAYMENT_ID,
                        RECEIPT_PAYMENT_DETAIL_ID: element.RECEIPT_PAYMENT_DETAIL_ID,
                        DOCUMENT_ID: element.DOCUMENT_ID,
                        BILL_ID: element.BILL_ID,
                        DOCUMENT_NUMBER: element.DOCUMENT_NUMBER,
                        COIN_SAT_ID: element.COIN_SAT_ID,
                        EXCHANGE_RATE: element.EXCHANGE_RATE,
                        RECEIVER_PAYMENT_METHOD_ID: element.RECEIVER_PAYMENT_METHOD_ID,
                        PARTIALITY_NUMBER: element.PARTIALITY_NUMBER,
                        PREVIOUS_BALANCE_AMOUNT: element.PREVIOUS_BALANCE_AMOUNT,
                        PAID_AMOUNT: element.PAID_AMOUNT,
                        UNPAID_BALANCE_AMOUNT: element.UNPAID_BALANCE_AMOUNT,
                        index: id,
                        isChecked: true,
                        CURRENCY: moneda.NAME,
                        CONDICIONAL: docCon.BILL_PAYMENT_METHOD_KEY,
                        LAST_PAID_AMOUNT: element.LAST_PAID_AMOUNT,
                        UUID: element.UUID,
                        IVA_FACTOR: element.IVA_FACTOR,
                        IVA_AMOUNT: element.IVA_AMOUNT,
                        SUBTOTAL_BEFORE_TAX: element.SUBTOTAL_BEFORE_TAX
                    });
                });
                setTimeout( () => {
                    this.dataSource.data = this.listaReciboPagoDocumento;
                    this.calcularTotal();
                });
            },
            (error) => {
            console.log( error as any);
            }
        );
    }

    buildForm() {
        this.reciboPagoAgregar = this.formBuilder.group({
            horaPago: this.formBuilder.control(null, [Validators.required]),
            fechaPago: this.formBuilder.control(null, [Validators.required] ),
            tipoCambio: this.formBuilder.control(null, [Validators.required] ),
            monto: this.formBuilder.control(null, [Validators.required, Validators.pattern(/^\d*(?:[.,]\d{1,2})?$/)] ),
            moneda: this.formBuilder.control(null, [Validators.required]),
            numOperacion: this.formBuilder.control(null),
            formaPago: this.formBuilder.control(null, [Validators.required]),
            cuentaOrdenante: this.formBuilder.control(null),
            cuentaBeneficiario: this.formBuilder.control(null),
        });

        this.reciboPagoAgregar.controls['tipoCambio'].setValue(1);
    }

    cerrarModal() {
        this.dataService.dialogRef.close();
    }

    timbrar() {
        const metodo = 'RecepcionPago/timbrar';
        this.reciboPago.RECEIPT_PAYMENT_ID = this.dataService.id;
        this._generalService.metodoCallParams(this.reciboPago, metodo).subscribe(
                (result) => {
                this.dataService.guardado = true;
                },
                (error) => {
                const errorMsj =  error as any;
                console.log(errorMsj);
                }
            );
    }

    consultarCompania() {
        const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
        const idCompania = usuarioSession.COMPANY_ID;
        const params = {
            idCompania
        };
        this._generalService.metodoCallParams(params, `factura/consultEmisor/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    if (res[0].BILL_TAX_REGIME_ID !== null && res[0].BILL_TAX_REGIME_ID !== undefined && this.dataService.tipo !== 'editar') {
                        this.BILL_TAX_REGIME_ID = res[0].BILL_TAX_REGIME_ID;
                    }
                }
            },
            (error) => {
                console.log( error as any);
            }
        );
    }

    consultarFormaPago() {
        this._generalService.metodoCall(`factura/getFormaPago/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaFormaPago = res;
                    const index1 = this.listaFormaPago.findIndex((element) => element.BILL_PAYMENT_FORM_KEY == 99);
                    this.listaFormaPago.splice(index1, 1);
                } else {
                    this.listaFormaPago = [];
                }
            },
            (error) => {
                this.listaFormaPago = [];
                console.log( error as any);
            }
        );
    }

    consultarCuentaOrdenante() {
        this._generalService.metodoCall(`RecepcionPago/getCuentaOrdenante?CUSTOMER_ID=`+ this.idCliente).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaCuentaOrdenante = res;
                } else {
                    this.listaCuentaOrdenante = [];
                }
            },
            (error) => {
                this.listaCuentaOrdenante = [];
                console.log( error as any);
            }
        );
    }

    consultarCuentaBeneficiario() {
        const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
        const idCompania = usuarioSession.COMPANY_ID;

        this._generalService.metodoCall(`RecepcionPago/getCuentaBeneficiario?COMPANY_ID=` + idCompania).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaCuentaBeneficiario = res;
                } else {
                    this.listaCuentaBeneficiario = [];
                }
            },
            (error) => {
                this.listaCuentaBeneficiario = [];
                console.log( error as any);
            }
        );
    }

    consultarMoneda() {
        this._generalService.metodoCall(`RecepcionPago/getMoneda/`).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaMoneda = res;
                    this.reciboPagoAgregar.controls['moneda'].setValue(this.listaMoneda[0].COIN_SAT_ID);
                } else {
                    this.listaMoneda = [];
                }
            },
            (error) => {
                this.listaMoneda = [];
                console.log( error as any);
            }
        );
    }

    consultarDocumentos() {
        this._generalService.metodoCall(`RecepcionPago/getDocumentos?CUSTOMER_ID=` + this.idCliente).subscribe(
            (result) => {
                const res = JSON.parse(result);
                if (res !== null && res !== undefined && res.length > 0) {
                    this.listaDocumento = res;
                    this.listaDocumentoSelect = this.listaDocumento.filter((element) => element.PREVIOUS_BALANCE_AMOUNT > 0);
                    this.viewDataDoc = this.listaDocumentoSelect.slice(0, this.itemsShowDoc);
                    this.viewDataDocEdit = this.viewDataDoc;
                    this.listaDocumentoEdit = JSON.parse(result);
                } else {
                    this.listaDocumento = [];
                }
            },
            (error) => {
                this.listaDocumento = [];
                console.log( error as any);
            }
        );
    }

    regresar() {
        this.siguiente = false;
        this.establecerValoresPorDefecto();
    }

    onNext() {
        if (this.validarForm()) {
            let FECHA;
            if (this.dataService.tipo != 'editar'){
                 FECHA = this.reciboPagoAgregar.controls['fechaPago'].value.format('YYYY-MM-DD');
            } else{
                const fechComplet = this.reciboPagoAgregar.controls['fechaPago'].value;
                FECHA = fechComplet.split(' ', 1);
            }
            
            const hora = this.reciboPagoAgregar.controls['horaPago'].value;
            const fechHora = (FECHA + ' ' + hora /*+ ':00'*/);
            this.reciboPagoDetalle.PAYMENT_DATE = (fechHora);
            this.reciboPagoDetalle.AMOUNT = this.reciboPagoAgregar.controls['monto'].value;
            this.reciboPagoDetalle.COIN_SAT_ID = this.reciboPagoAgregar.controls['moneda'].value;
            this.reciboPagoDetalle.RECEIVER_PAYMENT_FORM_ID = this.reciboPagoAgregar.controls['formaPago'].value;
            this.reciboPagoDetalle.NUM_OPERATION = this.reciboPagoAgregar.controls['numOperacion'].value;
            this.reciboPagoDetalle.ORIGINATOR_BACK_ACCOUNT_ID = this.reciboPagoAgregar.controls['cuentaOrdenante'].value;
            this.reciboPagoDetalle.BENEFICIARY_BACK_ACCOUNT_ID = this.reciboPagoAgregar.controls['cuentaBeneficiario'].value;
            this.reciboPagoDetalle.EXCHANGE_RATE = this.reciboPagoAgregar.controls['tipoCambio'].value;

            if(this.reciboPagoDetalle.ORIGINATOR_BACK_ACCOUNT_ID != null) {
                const originator = this.listaCuentaOrdenante.find((element) => element.ORIGINATOR_BACK_ACCOUNT_ID === this.reciboPagoDetalle.ORIGINATOR_BACK_ACCOUNT_ID);
                this.reciboPagoDetalle.RFC_ORIGINATOR_ACCOUNT = originator.RFC;
                this.reciboPagoDetalle.ORIGINATOR_ACCOUNT = originator.ACCOUNT;
            }
            
            if(this.reciboPagoDetalle.BENEFICIARY_BACK_ACCOUNT_ID != null) {
                const beneficiary = this.listaCuentaBeneficiario.find((element) => element.BENEFICIARY_BACK_ACCOUNT_ID === this.reciboPagoDetalle.BENEFICIARY_BACK_ACCOUNT_ID);
                this.reciboPagoDetalle.RFC_BENEFICIARY_ACCOUNT = beneficiary.RFC;
                this.reciboPagoDetalle.BENEFICIARY_ACCOUNT = beneficiary.ACCOUNT;
            }            

            this.siguiente = true;
        } else {
            this.siguiente = false;
        }
    }

    guardarReciboPagoDetalleHeader() {
        this.validarFormulario();
        if (this.formularioValido) {
        this.mapearDatosFormControlEnModelo();
        this.agregarReciboPagoDetalle();
        }
    }

    guardarReciboPagoDetalleRow() {
        this.validarFormulario();
        if (this.formularioValido) {
            this.mapearDatosFormControlEnModelo();
            this.editarReciboPagoDetalle();
        }
    }

    agregarReciboPagoDetalle() {
        let index = 0;
        if (this.listaReciboPagoDocumento.length === 0) {
             index = 0;
        } else {
             index = this.listaReciboPagoDocumento.length;
        }
        this.reciboPagoDocumento.index = index;
        this.listaReciboPagoDocumentoAgregar[index] = JSON.parse(JSON.stringify(this.reciboPagoDocumento));
        this.listaReciboPagoDocumento.push(JSON.parse(JSON.stringify(this.reciboPagoDocumento)));

        this.seEstaAgregando = false;
        this.seEstaEditando = false;
        setTimeout( () => {
          this.dataSource.data = this.listaReciboPagoDocumento;
          this.calcularTotal();
        });
        /*if (this.generarPolizaDolaresForm.value) {
          this.confirmarCambiarTipoCambio();
        } */
      }

      editarReciboPagoDetalle() {
        const index1 = this.listaReciboPagoDocumento.findIndex((element) => element.index === this.reciboPagoDocumento.index);
        // const index2 = this.listaFacturaDetalleAgregar.findIndex((element) => element.index === this.facturaDetalle.index);
        this.listaReciboPagoDocumentoAgregar[index1] = this.reciboPagoDocumento;
        this.listaReciboPagoDocumento[index1] =  this.reciboPagoDocumento;
        this.seEstaAgregando = false;
        this.seEstaEditando = false;
        setTimeout( () => {
          this.dataSource.data = this.listaReciboPagoDocumento;
          this.calcularTotal();
        });
      }

    setAccionAgregar() {
        this.establecerValoresPorDefecto();
        this.seEstaEditando = false;
        this.seEstaAgregando = true;
        /***************************INFINITE SELECT**********************************/    
         setTimeout(() => 
                    this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent()),
                0);
        /***************************INFINITE SELECT**********************************/
        this.viewDataDoc = this.listaDocumentoSelect.slice(0, 10);
    }

    cancelarAccion() {
    this.establecerValoresPorDefecto();
    }

    validarFormulario() {
        this.formularioValido = false;
        const campoRequerido = 'Favor de llenar los campos requeridos';
        this.resaltarCamposConErrores();
        if (
            this.documentoControl.invalid ||
            this.UUIDControl.invalid ||
            this.monedaControl.invalid ||
            this.tipoCambioControl.invalid ||
            this.saldoAnteriorControl.invalid ||
            this.importePagadoControl.invalid ||
            this.saldoControl.invalid ||
            this.subtotalController.invalid ||
            this.IVAController.invalid
        ) {
            this._generalService.toastCall(campoRequerido);
            return;
        }

        /*if (this.facturaDetalle.DOCUMENT_DETAIL_ID !== null &&  this.facturaDetalle.totalFaltante !== null) {
            this._generalService.toastCall('La cantidad sobrepaso al limite de la venta (Maximo ' + (this.facturaDetalle.totalFaltante) + ')');
            return;
        }*/

        this.formularioValido = true;
    }

    resaltarCamposConErrores() {
        this.documentoControl.markAsTouched();
        this.UUIDControl.markAsTouched();
        this.monedaControl.markAsTouched();
        this.tipoCambioControl.markAsTouched();
        this.saldoAnteriorControl.markAsTouched();
        this.importePagadoControl.markAsTouched();
        this.saldoControl.markAsTouched();
        this.subtotalController.markAsTouched();
        this.IVAController.markAsTouched();
    }

    mapearDatosFormControlEnModelo() {
        //aqui se mapea de control al modelo
        this.reciboPagoDocumento.BILL_ID = this.documentoControl.value;
        this.reciboPagoDocumento.DOCUMENT_ID = this.UUIDControl.value;
        const arrayDocument = this.listaDocumento.find((element) => element.BILL_ID === this.reciboPagoDocumento.BILL_ID);
        this.reciboPagoDocumento.DOCUMENT_NUMBER = arrayDocument.BILL_NUMBER;
        this.reciboPagoDocumento.RECEIVER_PAYMENT_METHOD_ID = arrayDocument.RECEIVER_PAYMENT_METHOD_ID;
        this.reciboPagoDocumento.COIN_SAT_ID = this.monedaControl.value;
        this.reciboPagoDocumento.PREVIOUS_BALANCE_AMOUNT = this.saldoAnteriorControl.value;
        this.reciboPagoDocumento.PAID_AMOUNT = +this.importePagadoControl.value;
        this.reciboPagoDocumento.UNPAID_BALANCE_AMOUNT = +this.saldoControl.value;
        this.reciboPagoDocumento.EXCHANGE_RATE = this.tipoCambioControl.value;
        const moneda = this.listaMoneda.find((element) => element.COIN_SAT_ID === this.reciboPagoDocumento.COIN_SAT_ID);
        this.reciboPagoDocumento.CURRENCY = moneda.NAME;
        this.reciboPagoDocumento.isChecked = true;
        this.reciboPagoDocumento.CONDICIONAL = arrayDocument.BILL_PAYMENT_METHOD_KEY;
        this.reciboPagoDocumento.IVA_FACTOR = this.IVAFactorController.value;
        this.reciboPagoDocumento.IVA_AMOUNT = this.IVAController.value;
        this.reciboPagoDocumento.SUBTOTAL_BEFORE_TAX = this.subtotalController.value;
    }

    establecerValoresPorDefecto() {
        this.seEstaAgregando = false;
        this.seEstaEditando = false;

        this.documentoControl.enable();
        this.documentoControl.reset();
        this.UUIDControl.reset();
        this.monedaControl.reset();
        this.tipoCambioControl.reset();
        this.saldoAnteriorControl.reset();
        this.importePagadoControl.reset();
        this.saldoControl.reset();
        this.subtotalController.reset();
        this.IVAController.reset();
        this.itemsShowDoc = 10;
        this.monedaControl.setValue(this.listaMoneda[0].COIN_SAT_ID);
        
    }

    establecerDetalle(reciboPagoDocumento: ReciboPagoDocumento) {

        this.seEstaAgregando = false;
        this.seEstaEditando = true;
        /***************************INFINITE SELECT**********************************/    
         setTimeout(() => 
                    this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent()),
                0);
        /***************************INFINITE SELECT**********************************/
        this.reciboPagoDocumento = reciboPagoDocumento;
        this.reciboPagoDocumento.DOCTOS_RELATED_RECEIPT_PAYMENT_ID = reciboPagoDocumento.DOCTOS_RELATED_RECEIPT_PAYMENT_ID;
        //this.reciboPagoDetalle = true;

        this.moverSeleccion();
        
        //aqui se pasan del model a los controls
        this.documentoControl.setValue(this.reciboPagoDocumento.BILL_ID);
        this.UUIDControl.setValue(this.reciboPagoDocumento.DOCUMENT_ID);
        this.monedaControl.setValue(this.reciboPagoDocumento.COIN_SAT_ID);
        this.saldoAnteriorControl.setValue(+this.reciboPagoDocumento.PREVIOUS_BALANCE_AMOUNT);
        this.importePagadoControl.setValue(+this.reciboPagoDocumento.PAID_AMOUNT);
        this.saldoControl.setValue(+this.reciboPagoDocumento.UNPAID_BALANCE_AMOUNT);
        this.reciboPagoDocumento.EXCHANGE_RATE = 1;
        this.tipoCambioControl.setValue(this.reciboPagoDocumento.EXCHANGE_RATE);

        this.documentoControl.disable();

        this.transaccionEnCurso = false;
    }

    moverSeleccion() {
        /***************************INFINITE SELECT**********************************/
        const index = this.listaDocumentoEdit.findIndex(x => x.BILL_ID == this.reciboPagoDocumento.BILL_ID);
        var a = this.listaDocumentoEdit.splice(index,1);
        this.listaDocumentoEdit.unshift(a[0]);
        this.itemsShowDoc = 10;
        this.viewDataDocEdit = this.listaDocumentoEdit.slice(0, 10);
        /***************************INFINITE SELECT**********************************/
    }

    eliminarReciboPagoDetalle(reciboPagoDocumento: ReciboPagoDocumento, id) {

        const metodo = 'RecepcionPago/deleteReceiptPaymentDocument';
        this._generalService.metodoCallParams(reciboPagoDocumento, metodo).subscribe(
            (result) => {
                this._generalService.toastCall('Se ha eliminado el renglon exitosamente!');
                this.eliminar(id);
                this.consultarDocumentos();
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );

    }

    eliminar(id) {
        const index1 = this.listaReciboPagoDocumento.findIndex((element) => element.index === id);
        // const index2 = this.listaFacturaDetalleAgregar.findIndex((element) => element.index === id);
        this.listaReciboPagoDocumento.splice(index1, 1);
        this.listaReciboPagoDocumentoAgregar.splice(index1, 1);
        setTimeout( () => {
            this.dataSource.data =this.listaReciboPagoDocumento;
            this.calcularTotal();
        });
    }

    guardarReciboPago() {
        if (this.validarGuardar()) {
            let metodo = 'RecepcionPago/insertReceiptPayment';
            this.reciboPago.RECEIPT_PAYMENT_ID = null;
            if (this.dataService.tipo === 'editar') {
            metodo = 'RecepcionPago/updateReceiptPayment';
                this.reciboPago.RECEIPT_PAYMENT_ID = this.dataService.id;
            } else {
                this.reciboPago.TAX_REGIME_ID = this.BILL_TAX_REGIME_ID;
            }
            this.reciboPago.CUSTOMER_ID = this.idCliente;
            this.reciboPagoDetalle.COMMENTS = this.commentsControl.value;
            this.reciboPago.BILL_STATUS_ID = 1;
            const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
            const idOrganizacion = usuarioSession.ORGANIZATION_ID;
            this.reciboPago.ORGANIZATION_ID = idOrganizacion;
            //this.reciboPago.idDocuments = this.idDocuments;
            const idCompania = usuarioSession.COMPANY_ID;
            

            const params = {
                reciboPagoModel: this.reciboPago,
                reciboPagoDetalleModel: this.reciboPagoDetalle,
                reciboPagoDocumentoModel: this.listaReciboPagoDocumento,
                COMPANY_ID: idCompania
            };

            this._generalService.metodoCallParams(params, metodo).subscribe(
                (result) => {
                this.dataService.guardado = true;
               // this.cerrarModal();
                if(this.dataService.tipo === 'editar'){
                    this._generalService.toastCall('El registro se modificó exitosamente!');
                } else {
                    
                    this.reciboPago.RECEIPT_PAYMENT_ID = +result.data;
                    this.dataService.id = +result.data;
                    this._generalService.toastCall('El registro se agregó exitosamente!');
                    this.getReciboPago(this.dataService.id);
                }
                },
                (error) => {
                const errorMsj =  error as any;
                console.log(errorMsj);
                } 
            );
        }
    }

    validarGuardar() {
       if (!this.reciboPagoAgregar.controls['fechaPago'].valid) {
             this._generalService.toastCall('La fecha de pago es requerida');
             this.reciboPagoAgregar.controls['fechaPago'].markAsTouched();
             return false;
         }
        if (!this.reciboPagoAgregar.controls['horaPago'].valid) {
             this._generalService.toastCall('La hora de pago es requerida');
             this.reciboPagoAgregar.controls['horaPago'].markAsTouched();
             return false;
         } 
         if (!this.reciboPagoAgregar.controls['tipoCambio'].valid) {
             this._generalService.toastCall('El tipo de cambio es requerido');
             this.reciboPagoAgregar.controls['tipoCambio'].markAsTouched();
             return false;
         }
         if (!this.reciboPagoAgregar.controls['monto'].valid) {
             this._generalService.toastCall('El monto es requerido');
             this.reciboPagoAgregar.controls['monto'].markAsTouched();
             return false;
         }
         if (!this.reciboPagoAgregar.controls['moneda'].valid) {
             this._generalService.toastCall('La moneda es requerida');
             this.reciboPagoAgregar.controls['moneda'].markAsTouched();
             return false;
         }
         /*if (!this.reciboPagoAgregar.controls['numOperacion'].valid) {
             this._generalService.toastCall('El número de operación es requerido');
             this.reciboPagoAgregar.controls['numOperacion'].markAsTouched();
             return false;
         }*/
         if (!this.reciboPagoAgregar.controls['formaPago'].valid) {
             this._generalService.toastCall('La forma de pago es requerida');
             this.reciboPagoAgregar.controls['formaPago'].markAsTouched();
             return false;
         }
         /*if (!this.reciboPagoAgregar.controls['cuentaOrdenante'].valid) {
             this._generalService.toastCall('La cuenta del ordenante es requerida');
             this.reciboPagoAgregar.controls['cuentaOrdenante'].markAsTouched();
             return false;
         }
         if (!this.reciboPagoAgregar.controls['cuentaBeneficiario'].valid) {
             this._generalService.toastCall('La cuenta del beneficiario es requerida');
             this.reciboPagoAgregar.controls['cuentaBeneficiario'].markAsTouched();
             return false;
         }*/
         if(this.reciboPagoAgregar.controls['monto'].value != this.importePagado) {
             this._generalService.toastCall('El monto ingresado no es igual a la sumatoria del importe pagado');
             return false;
         }

        let cantidadAguardar = 0;
        let index = 0;
        let falloGrid = false;
        let stringError = '';
        this.listaReciboPagoDocumentoAgregar.forEach((element) => {
            index++;
            if (element.isChecked) {
                if (element.BILL_ID === null || element.BILL_ID === undefined ) {
                   // this._generalService.toastCall('La Unidad es requerida, error en el renglón ' + index);
                    stringError += 'Error Renglón ' + index + ' el documento es requerido, ';
                    falloGrid = true;
                }
                if (element.PAID_AMOUNT === null || element.PAID_AMOUNT === undefined ) {
                    // this._generalService.toastCall('La Unidad es requerida, error en el renglón ' + index);
                     stringError += 'Error Renglón ' + index + ' el importe pagado es requerido, ';
                     falloGrid = true;
                 }
                cantidadAguardar++;
            }
        });

        if (falloGrid) {
            this._generalService.toastCall(stringError);
            return false;
        }
        if (cantidadAguardar > 0) {
            if(!falloGrid){
                return true;
            } 
        } else {
            this._generalService.toastCall('Debe de activar por lo menos un renglón.');
            return false;
        }

    }

    validarForm() {
         if (!this.reciboPagoAgregar.controls['fechaPago'].valid) {
             this._generalService.toastCall('La fecha de pago es requerida');
             this.reciboPagoAgregar.controls['fechaPago'].markAsTouched();
             return false;
         }
         if (!this.reciboPagoAgregar.controls['horaPago'].valid) {
             this._generalService.toastCall('La hora de pago es requerida');
             this.reciboPagoAgregar.controls['horaPago'].markAsTouched();
             return false;
         } 
         if (!this.reciboPagoAgregar.controls['tipoCambio'].valid) {
             this._generalService.toastCall('El tipo de cambio es requerido');
             this.reciboPagoAgregar.controls['tipoCambio'].markAsTouched();
             return false;
         }
         if (!this.reciboPagoAgregar.controls['monto'].valid) {
             this._generalService.toastCall('El monto es requerido');
             this.reciboPagoAgregar.controls['monto'].markAsTouched();
             return false;
         }
         if (!this.reciboPagoAgregar.controls['moneda'].valid) {
             this._generalService.toastCall('La moneda es requerida');
             this.reciboPagoAgregar.controls['moneda'].markAsTouched();
             return false;
         }
         /*if (!this.reciboPagoAgregar.controls['numOperacion'].valid) {
             this._generalService.toastCall('El número de operación es requerido');
             this.reciboPagoAgregar.controls['numOperacion'].markAsTouched();
             return false;
         }*/
         if (!this.reciboPagoAgregar.controls['formaPago'].valid) {
             this._generalService.toastCall('La forma de pago es requerida');
             this.reciboPagoAgregar.controls['formaPago'].markAsTouched();
             return false;
         }
         /*if (!this.reciboPagoAgregar.controls['cuentaOrdenante'].valid) {
             this._generalService.toastCall('La cuenta del ordenante es requerida');
             this.reciboPagoAgregar.controls['cuentaOrdenante'].markAsTouched();
             return false;
         }
         if (!this.reciboPagoAgregar.controls['cuentaBeneficiario'].valid) {
             this._generalService.toastCall('La cuenta del beneficiario es requerida');
             this.reciboPagoAgregar.controls['cuentaBeneficiario'].markAsTouched();
             return false;
         }*/

         return true;

    }

    setearNumFolio(event: any, index: number) {
        if (event !== undefined && event !== null) {
            const documentoValid = this.listaReciboPagoDocumento.filter((element) => element.BILL_ID === event.value);
            if(documentoValid.length == 0) {
                const documento = this.listaDocumento.find((element) => element.BILL_ID === event.value);
                if (documento.BILL_ID !== null) {
                    this.importePagadoControl.reset();
                    this.UUIDControl.setValue(documento.UUID);
                    this.saldoAnteriorControl.setValue(documento.PREVIOUS_BALANCE_AMOUNT);
                    documento.EXCHANGE_RATE = 1;
                    this.IVAFactorController.setValue(documento.IVA_FACTOR)
                    this.tipoCambioControl.setValue(documento.EXCHANGE_RATE);
                    const moneda = this.listaMoneda.find((element) => element.NAME === documento.CURRENCY);
                    if (moneda.COIN_SAT_ID !== null) {
                        this.monedaControl.setValue(moneda.COIN_SAT_ID);
                    } else {
                        this.UUIDControl.reset();
                        this.tipoCambioControl.reset();
                        this.saldoAnteriorControl.reset();
                        this.monedaControl.reset();
                    }
                } else {
                    this.UUIDControl.reset();
                    this.tipoCambioControl.reset();
                    this.saldoAnteriorControl.reset();
                    this.monedaControl.reset();
                }
            } else {
                this.UUIDControl.reset();
                this.tipoCambioControl.reset();
                this.saldoAnteriorControl.reset();
                this.monedaControl.reset();
                this._generalService.toastCall('El documento seleccionado ya se encuentra agregado en la tabla de documentos');
            }
        } else {
            this.UUIDControl.reset();
            this.tipoCambioControl.reset();
            this.saldoAnteriorControl.reset();
            this.monedaControl.reset();
        }
    }

    calcularTotal() {
        // SubTotal Impuestos Total
        let sumaSaldoAnterior = 0;
        let sumaImportePagado = 0;
        let sumaTotal = 0;
        for (let i = 0; i < this.listaReciboPagoDocumento.length; i++) {
            if (this.listaReciboPagoDocumento[i].isChecked) {
                sumaSaldoAnterior += +this.listaReciboPagoDocumento[i].PREVIOUS_BALANCE_AMOUNT;
                sumaImportePagado += +this.listaReciboPagoDocumento[i].PAID_AMOUNT;
                sumaTotal += +this.listaReciboPagoDocumento[i].UNPAID_BALANCE_AMOUNT;
            }
        }
        this.saldoAnterior = +sumaSaldoAnterior.toFixed(2);
        this.importePagado = +sumaImportePagado.toFixed(2);
        this.total = +sumaTotal.toFixed(2);
    }

    calcularSaldo(importe: any) {
        if (importe !== null && importe !== undefined) {
            if(parseFloat(this.reciboPagoDetalle.AMOUNT) >= (parseFloat(this.importePagadoControl.value))) {  
                const saldo = parseFloat(this.saldoAnteriorControl.value) - parseFloat(this.importePagadoControl.value);
                if(saldo >= 0) {
                    const documento = this.listaDocumento.find((element) => element.BILL_ID === this.documentoControl.value);
                    if(documento.BILL_PAYMENT_METHOD_KEY != "PPD" && saldo != 0) {
                        this.saldoControl.reset();
                        this._generalService.toastCall('El importe pagado no es igual al saldo anterior');
                    } else {

                        /*let subtotal = (documento.SUBTOTAL_BEFORE_TAX * this.importePagadoControl.value) / documento.PREVIOUS_BALANCE_AMOUNT;
                        this.subtotalController.setValue(subtotal.toFixed(2));

                        let iva = (documento.TOTAL_IVA * this.importePagadoControl.value) / documento.PREVIOUS_BALANCE_AMOUNT;
                        this.IVAController.setValue(iva.toFixed(2));

                        this.saldoControl.setValue(saldo.toFixed(2));*/

                        //Si los productos manejan precios sin iva en el catálogo
                        if(!this.containsTaxGeneral){
                            //let iva = (this.importePagadoControl.value / 1.16);
                            //this.IVAController.setValue(iva.toFixed(2));

                            //let subtotal = (this.importePagadoControl.value);
                            //this.subtotalController.setValue(subtotal.toFixed(2));

                            //this.saldoControl.setValue(saldo.toFixed(2));

                            //
                            let subtotal = (this.importePagadoControl.value / 1.16);
                            this.subtotalController.setValue(subtotal.toFixed(2));

                            let iva = (this.importePagadoControl.value - Number(subtotal.toFixed(2)));
                            this.IVAController.setValue(iva.toFixed(2));

                            this.saldoControl.setValue(saldo.toFixed(2));
                        }
                        //Si los productos manejan precios con iva en el catálogo
                        else
                        {

                            //let iva = (this.importePagadoControl.value * .16);
                            let iva = (this.importePagadoControl.value * 16) / 116;
                            this.IVAController.setValue(iva.toFixed(2));

                            let subtotal = (this.importePagadoControl.value - this.IVAController.value);
                            this.subtotalController.setValue(subtotal.toFixed(2));

                            this.saldoControl.setValue(saldo.toFixed(2));
                        }
                    }
                } else {
                    this.saldoControl.reset();
                    this._generalService.toastCall('El importe pagado no puede ser mayor al saldo');
                }
            } else {
                this.saldoControl.reset();
                this._generalService.toastCall('El importe pagado no puede ser mayor al monto del recibo de pago');
            }
        } else {
            this.saldoControl.reset();
        }
    }

    validarMonto(importe: any) {
        if (importe !== null && importe !== undefined) {
            if(parseFloat(this.reciboPagoAgregar.controls['monto'].value) < this.importePagado) {
                this._generalService.toastCall('El monto no puede ser menor al importe pagado');
                this.reciboPagoAgregar.controls['monto'].setValue(this.importePagado);
                return false;
            }
        }
    }

    activarRow(element, event) {
        const index = this.listaReciboPagoDocumento.findIndex((obj) => obj.index === element.index);
        if (event.checked) {
            this.listaReciboPagoDocumentoAgregar[index].isChecked = true;

        } else {
            this.listaReciboPagoDocumentoAgregar[index].isChecked = false;
        }
        this.calcularTotal();
    }

    eliminarRow(element) {
        const index = this.listaReciboPagoDocumento.findIndex((obj) => obj.index === element.index);
        if (element.DOCTOS_RELATED_RECEIPT_PAYMENT_ID !== null && element.DOCTOS_RELATED_RECEIPT_PAYMENT_ID !== undefined) {
            // this.listaReciboPagoDocumento[index].isChecked = false;
            this.eliminarReciboPagoDetalle(this.listaReciboPagoDocumento[index], element.index);
        } else {
            this.eliminar(element.index);
        }
    }

    toggleAccount(event) {
        if(event) {
            const formPag = this.listaFormaPago.find((element) => element.BILL_PAYMENT_FORM_ID === event);
            const requireAccount = formPag.REQUIRE_ACCOUNT;
            const keyPago = formPag.BILL_PAYMENT_FORM_KEY + "";

            if (requireAccount)
            {
                this.mostrarBeneficiario = true;
                this.mostrarOrdenante = true;
            }
            else {
                this.mostrarOrdenante = false;
                this.mostrarBeneficiario = false;
                this.reciboPagoAgregar.controls["cuentaOrdenante"].setValue(undefined);
                this.reciboPagoAgregar.controls["cuentaBeneficiario"].setValue(undefined);
            }
        } else {
            this.mostrarOrdenante = false;
            this.mostrarBeneficiario = false;
            this.reciboPagoAgregar.controls["cuentaOrdenante"].setValue(undefined);
            this.reciboPagoAgregar.controls["cuentaBeneficiario"].setValue(undefined);
        }
    }

    insertBeneficiario() {
        this.dataService.tipoModal = 'agregar';
        const dialogRef = this.dialog.open(BeneficiarioDetalleComponent, {disableClose: true, width: '50vw', height: '65vh', maxWidth: '50vw', maxHeight: '70vh', panelClass: 'full-width-dialog'});
        this.dataService.dialogModal = dialogRef;
        dialogRef.afterClosed().subscribe((result) => {
          if (this.dataService.guardadoModal) {
            this._generalService.toastCall('El registro se agregó exitosamente!');
            this.consultarCuentaBeneficiario();
          }
        });
    }

    insertOrdenante() {
        this.dataService.tipoModal = 'agregar';
        this.dataService.idCliente = this.idCliente;
        const dialogRef = this.dialog.open(OrdenanteDetalleComponent, {disableClose: true, width: '50vw', height: '65vh', maxWidth: '50vw', maxHeight: '70vh', panelClass: 'full-width-dialog'});
        this.dataService.dialogModal = dialogRef;
        dialogRef.afterClosed().subscribe((result) => {
          if (this.dataService.guardadoModal) {
            this._generalService.toastCall('El registro se agregó exitosamente!');
            this.consultarCuentaOrdenante();
          }
        });
    }

    onKeyUpDoc(val: any) {
        let arr: any[];
        if (val.currentTarget.value != "") {
            if(this.seEstaEditando) {
                this.arrayFilteredDoc = this.listaDocumentoEdit.filter((obj) => {
                    return obj.BILL_NUMBER.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
                  })
            } else {
               this.arrayFilteredDoc = this.listaDocumentoSelect.filter((obj) => {
                return obj.BILL_NUMBER.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
              })
            }
          

          arr = this.arrayFilteredDoc.slice(0, this.filteredItemsShowDoc);
          this.isFilteredDoc = true;
        } else {
          /***************************INFINITE SELECT**********************************/
          // arr = this.filtroSATCodes;
          this.isFilteredDoc = false;
          this.filteredItemsShowDoc = 10;
          this.arrayFilteredDoc = undefined;
          arr = this.listaDocumentoSelect.slice(0, this.itemsShowDoc);
          /***************************INFINITE SELECT**********************************/
        }
        /***************************INFINITE SELECT**********************************/
        if(this.seEstaEditando) {
            this.viewDataDocEdit = arr;
        } else {
            this.viewDataDoc = arr;
        }
        /***************************INFINITE SELECT**********************************/
    }

    /***************************INFINITE SELECT**********************************/
    registerPanelScrollEvent() {
        const panel = this.selectElem.panel.nativeElement;
        panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
    }

    loadAllOnScroll(event) {
        if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
          if(this.isFilteredDoc) {
            if(this.filteredItemsShowDoc < this.arrayFilteredDoc.length) {
                this.filteredItemsShowDoc += 10;
                if(this.seEstaEditando) {
                    this.viewDataDocEdit = this.arrayFilteredDoc.slice(0, this.filteredItemsShowDoc);
                } else {
                    this.viewDataDoc = this.arrayFilteredDoc.slice(0, this.filteredItemsShowDoc);
                }
            }
          } else {
            if(this.seEstaEditando) {
                if(this.itemsShowDoc < this.listaDocumentoEdit.length) {
                    this.itemsShowDoc += 10;
                    this.viewDataDocEdit = this.listaDocumentoEdit.slice(0, this.itemsShowDoc);
                }
            } else {
                if(this.itemsShowDoc < this.listaDocumentoSelect.length) {
                    this.itemsShowDoc += 10;
                    this.viewDataDoc = this.listaDocumentoSelect.slice(0, this.itemsShowDoc);
                }
            }            
          }
        }
    }
    /***************************INFINITE SELECT**********************************/

}


// WEBPACK FOOTER //
// ./src/app/recibo-pago/agregar-editar/recibo-pago-detalle.component.ts